import { showOriginalUrl } from './getRevertToFullUrlContextMenuItem.locstring.json';
import loc from 'owa-localize';
import { closeLinkContextMenu, ReplaceLinkHandler } from '../../components/LinkContextMenu';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';

export function getRevertToFullUrlContextMenuItem(
    oldLinkId: string,
    anchorElement: HTMLAnchorElement,
    convertToFullUrlHandler: ReplaceLinkHandler,
    composeId: string
): IContextualMenuItem {
    return {
        name: loc(showOriginalUrl),
        key: 'RevertToFullUrl',
        onClick: () => {
            logUsage('AttachmentLinkViewRevertToFullUrl');
            closeLinkContextMenu();
            convertToFullUrlHandler(anchorElement.href, anchorElement.href);
        },
    };
}
